import React from 'react';

function SectionCheckboxIcon({theme = ''}) {
  let color = '#';
  switch (theme) {
    case 'nursing':
      color += 'E53935';
      break;
    case 'pharmacy':
      color += 'F9A825';
      break;
    case 'anesthesia':
      color += '00897B';
      break;
    case 'patient-care':
      color += '01C1D8';
      break;
    default:
      color += '404040';
  }
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18">
      <path fill={color} d="M8.6,12.4L8.6,12.4L8.6,12.4L5.4,9.2l1.3-1.3l1.9,1.9L12.4,6l1.3,1.3L8.6,12.4z M0,18h18V0H0V18z"/>
    </svg>
  )
}

export default SectionCheckboxIcon;



// WEBPACK FOOTER //
// ./src/components/icons/SectionCheckboxIcon.js